
/**
 * @module ui/templates/election/riding-dialog
 */
import tgamConfig from "config/tgam";
import { getProp } from "utils/utils";

/**
 * Election riding modal dialog container
 * @param {String} id - Unique ID for the dialog
 * @param {Boolean} hidden - Whether the dialog should have a "hidden" attribute
 * @returns {String} Modal dialog container markup
 */
export default function ridingDialogTemplate(id, hidden = true) {
  if (getProp(tgamConfig, "meta.pagesubtype", "") !== "election" && getProp(tgamConfig, "meta.siteName", "") !== "homepage") {
    return "";
  }
  return `
    <div role="dialog" class="c-modal-dialog c-modal-dialog--light c-modal-dialog--scrollable c-modal-dialog--click-close js-modal-dialog-election-riding"
      id="${id}" aria-labelledby="${id}-title" aria-modal="true"${hidden ? " hidden" : ""}>
      <div class="c-modal-dialog__inner">
        <div class="c-modal-dialog__toolbar">
          <button type="button" class="c-button c-button--white-primary c-button--icon-only c-button--no-border" aria-label="Close riding modal">
            <svg class="c-button__icon" role="img" pointer-events="none" focusable="false" aria-hidden="true">
              <use xlink:href="${tgamConfig.env.svgSpritePath}#close-x"></use>
            </svg>
          </button>
        </div>
        <h2 id="${id}-title" class="u-visually-hidden"></h2>
        <div class="c-modal-dialog__contents"></div>
      </div>
    </div>
  `;
}
